import { useQuery, useMutation } from "@tanstack/react-query";
import logo from "../img/PpaLogo.svg";
import axios from "axios";
import Cookies from "universal-cookie";

export const useGetSubscriptionPlans = () => {
    return useQuery({
        queryKey: ["subscriptionPlans"],
        queryFn: async () => {
            const cookies = new Cookies();
            const response = await axios.get(
                process.env.REACT_APP_PAYMENT_SERVICE_URL + "subscriptions",
                {
                    headers: {
                        authorization: cookies.get("authorization"),
                        course: "renaissance",
                    },
                },
            );
            return response.data;
        },
    });
};

export const useUpdateSubscriptionPlans = () => {
    return useMutation({
        mutationFn: async (couponCode) => {
            const cookies = new Cookies();
            const response = await axios.post(
                process.env.REACT_APP_PAYMENT_SERVICE_URL + "applyReferralOrDiscount",
                {
                    code: couponCode,
                },
                {
                    headers: {
                        authorization: cookies.get("authorization"),
                        course: "renaissance",
                    },
                },
            );
            return response.data;
        },
    });
};

export const useInitiateSubscription = () => {
    return useMutation({
        mutationFn: async ({ subscriptionID, username, couponCode }) => {
            const cookies = new Cookies();

            const response = await axios.post(
                process.env.REACT_APP_PAYMENT_SERVICE_URL + "initiatePayment",
                {
                    subscriptionID,
                    username,
                    referralOrDiscountCode: couponCode,
                },
                {
                    headers: {
                        authorization: cookies.get("authorization"),
                        course: "renaissance",
                    },
                },
            );

            return response.data;
        },
    });
};

export const placeOrderAndShowRz = (email, orderId, key, amount, currency) => {
    try {
        console.log({ email, orderId, key, amount, currency });
        const name = email.split("@")[0];
        const options = {
            key: `${key}`,
            amount: `${amount}`.toString(),
            currency: `${currency}`,
            name: "Programming Pathshala",
            description: "Subscription Payment",
            image: { logo },
            order_id: `${orderId}`,
            handler: (response) => {
                console.log(response.razorpay_payment_id, { amount: amount, currency: currency });
                setTimeout(() => {
                    window.open(`${process.env.REACT_APP_NEW_DASHBOARD_URL}`, "_self");
                }, 2000);
            },
            prefill: {
                name,
                email,
                contact: "",
            },
            notes: {
                address: "",
            },
            theme: {
                color: "#444BAB",
            },
            config: {
                display: { hide: [{ method: "upi", flows: ["qr"] }] },
            },
        };

        const rzp1 = new window.Razorpay(options);
        rzp1.open();
    } catch (e) {
        console.log(e);
    }
};
